module.exports = __webpack_public_path__ + "img/icbc.2cb331ec.png";